
import { defineComponent, ref, onMounted, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useStore } from '@/store/index'
import { mdiAlphaQCircleOutline, mdiAlphaACircleOutline } from '@mdi/js'
import { toArray } from '@/utils/array'

export default defineComponent({
  setup() {
    const activeName = ref(0)
    const { t } = useI18n()
    const store = useStore()
    const faqCategories = computed(() => store.state.contact.faqCategories)

    onMounted(() => {
      store.dispatch('contact/fetchFaqCategories')
    })

    return {
      t,
      activeName,
      mdiAlphaQCircleOutline,
      mdiAlphaACircleOutline,
      store,
      faqCategories,
      toArray
    }
  },
})
